import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SearchBox from "components/__new/common/SearchBox";
import Table from "components/__new/common/Table";
import { renderStatusColor } from "utils/statusColor";
import DropdownNew from "utils/dropdown";
import Filter, { ActiveFilter } from "components/__new/common/Filter";
import DownloadAsCSV from "components/__new/common/DownloadAsCSV";
import DynamicHeadTag from "components/__new/common/DynamicHeadTag";
import useUrlQueryParams from "hooks/useUrlQueryParams";
import { TableContent } from "components/__new/common/TableContent";
import { toast } from 'react-toastify';
import ManageEarningsModal from 'components/__old/common/modals/manageEarnings';
import { DateFormat } from "utils/dateFormat";
import ReactToolTip from 'react-tooltip';
import FormDrawer from "components/__new/common/form-drawer";
import logger from "utils/logger";
import Pagination from "components/__new/common/pagination";
import Maybe from "components/__new/common/Maybe";
import processParams from "utils/processParams";
import useLoginInfo from "hooks/useLoginInfo";
import DialogBox from "utils/dialogBox";
import { Input, SelectInput } from "components/__new/common/form";
import BulkUpload from "components/__new/employees/BulkUpload";
import ContentLoading from "components/__new/common/ContentLoading";
import pluralize from "utils/pluralize";
import { ReactComponent as IconActivate } from "assets/images/icons/project-icons/activate.svg";
import { ReactComponent as IconDeactivate } from "assets/images/icons/project-icons/deactivate.svg";
import { ReactComponent as IconTrash } from "assets/images/icons/project-icons/thrash.svg";
import { ReactComponent as IconsTimes } from "assets/images/icons/project-icons/times.svg";
import { ReactComponent as ArrowDownIcon } from "assets/images/icons/arrow-down-white.svg";
import useMultiSelect from "hooks/useMultiSelect";
import * as employeesAction from "store/entities/employees/action";
import * as groupsAction from "store/entities/groups/action";
import { EmployeeInputModal, EmployeeEditDetailsModal, AssignToGroupModal, EmployeeUploadReviewCSVModal, EmployeeActionModal, EmployeeViewDataModal, ViewGroupDataModal, EditEmployeeGroupModal } from "components/__new/employees/Modal";
import DropDown from "components/__new/employees/DropDown";
import { ReactComponent as SingleUser } from "assets/images/icons/user.svg";
import { ReactComponent as GroupUser } from "assets/images/icons/userstwo.svg";
import useBanks from 'hooks/useBanks';


export const List = (props) => {
    const pageAccess = props.pageAccess || "all";
    
    const location = useLocation();
    const {userInfo} = useLoginInfo();
    const dispatch = useDispatch();
    const {urlQueryParams} = useUrlQueryParams();
    const { selections, toggleMultiSelectHeader, getMultiSelectBody, clearSelections } = useMultiSelect();
    const { employeesLoading, employees, employeesDownloadLoading, employeesDownload, employeeRoles } = useSelector((s) => s.entities.employees);
    const { groups } = useSelector((s) => s.entities.groups);
    const {banks, banksLoading} = useBanks(userInfo?.token);
    const { employeeBulkActivateLoading, employeeBulkActivateSuccess, employeeBulkDeactivateLoading, employeeBulkDeactivateSuccess, employeeBulkArchiveLoading, employeeBulkArchiveSuccess } = useSelector((s) => s.entities.employees);
    
    const downloadAsCSVRef = useRef();
    const printComponentRef = useRef();
    const [isOpenBulkUpload, setIsOpenBulkUpload] = useState(false);
    const [isOpenBulkUploadReview, setIsOpenBulkUploadReview] = useState(false);
    const [isEmployeeActionOpen, setIsEmployeeActionOpen] = useState(false);
    const [selectedEmployee, setSelectedEmployee] = useState(null);
    const [employeeDetails, setEmployeeDetails] = useState(null);
    const [actionToTake, setActionToTake] = useState("");
    const [isAddEmployeeOpen, setIsAddEmployeeOpen] = useState(false);
    const [isViewEmployeeOpen, setIsViewEmployeeOpen] = useState(false);
    const [isEditEmployeeOpen, setIsEditEmployeeOpen] = useState(false);
    const [isEditEmployeeGroupOpen, setIsEditEmployeeGroupOpen] = useState(false);
    const [isViewGroupOpen, setIsViewGroupOpen] = useState(false);
    const [listParams, setListParams] = useState({
        "page": 1,
        "limit": 20,
    });
    const [manageEarnings, setManageEarnings] = useState({
        "isOpen": false,
        "employee": {},
    });
    const [assignToGroupParams] = useState({
        "isOpen": false,
        "employee": "",
        params: {
            policyId: "",
            employeeId: "",
        },
    });
    const [showBulkActions, setShowBulkActions] = useState({
        activate: false,
        deactivate: false,
        delete: true,
    });
    const [deactivateEmployeeOpen, setDeactivateEmployeeOpen] = useState(false);
    const [deactivateEmployeeId, setDeactivateEmployeeId] = useState("");
    const [isAssignGroupOpen, setIsAssignGroupOpen] = useState(false);

    const getEmployeesMetrics = () => {
        dispatch(employeesAction.getEmployeeMetrics());
    }
    
    const getEmployees = () => {
        let params = {...listParams};

        params = processParams(urlQueryParams, params, "page", "number", 1, "page");
        params = processParams(urlQueryParams, params, "limit", "number", 20, "limit");
        params = processParams(urlQueryParams, params, "search", "string", "", "search");
        params = processParams(urlQueryParams, params, "startDate", "string", "", "startDate");
        params = processParams(urlQueryParams, params, "endDate", "string", "", "endDate");
        params = processParams(urlQueryParams, params, "role", "string", "", "jobTitle");

        if (pageAccess === "enrolled"){
            params = {...params, status: "active"};
        }
        else{
            params = processParams(urlQueryParams, params, "status", "string", "", "status");
        }
        setListParams(params);        
        dispatch(employeesAction.getAllEmployees(params));
    }


    const getGroupsB2b = () => {   
        dispatch(groupsAction.getGroupsB2b());
    }

    const getGroups = () => {   
        dispatch(groupsAction.getAllGroups());
    }
    
    
    const getAvailableRoles = () => {
        dispatch(employeesAction.getAllEmployeesRole());
    }

    const deleteAnEmployee = (params) => {
        const payload = { employeeId: params._id }
        dispatch(employeesAction.deleteAnEmployee(payload)).then(() => {
            setIsEmployeeActionOpen(false);
            getEmployees();
            getEmployeesMetrics();
        });
        toast("Deleting employee");
    }

/* 
    const displayWithdrawalsCount = (type) => {
        if (employeeMetricsLoading === true){
            return (<FontAwesomeIcon icon="circle-notch" spin />);
        }
        else{
            if (type === "total") return "(" + (NumberFormat(employeeMetrics?.data?.total?.count, "no-kobo") || "-") + ")";
            if (type === "active") return "(" + (NumberFormat(employeeMetrics?.data?.enrolled?.count, "no-kobo") || "-") + ")";
            if (type === "pending") return "(" + (NumberFormat(employeeMetrics?.data?.pending?.count, "no-kobo") || "-") + ")";
            if (type === "deactivated") return "(" + (NumberFormat(employeeMetrics?.data?.deactivated?.count, "no-kobo") || "-") + ")";
        }
    } */


    /* const resendInvite = async (id) => {
        const result = await DialogBox({
			title: "Resend Invite 😊",
			content: "Are you sure you want to carry out this action?",
			buttonYes: "Resend Invite",
			buttonNo: "Cancel",
		});
		if (result) {
            const params = {
                employeeId: id,
            }
            dispatch(employeesAction.resendInvite(params));
            toast("Resending invite");
        }
    } */
    
/* 
    const toggleAssignToGroup = (employee, groupPolicyId = '') => {
        setAssignToGroupParams({
            "isOpen": true,
            "employee": employee?.firstName + " " + employee?.lastName,
            params: {
                policyId: groupPolicyId,
                employeeId: employee?._id,
            },
        })
    } */


    const toggleManageEarnings = (action, employee='') => {
        setManageEarnings({isOpen: action, employee});
    }


    const activateEmployee = async (id) => {
        const result = await DialogBox({
			title: "Activate Employee 😊",
			content: "Are you sure you want to activate this employee? Employee will have access to Earnipay",
			buttonYes: "Activate",
			buttonNo: "Cancel",
		});
		if (result) {
            dispatch(employeesAction.activateEmployee(id)).then(() => {
                getEmployees();
                getEmployeesMetrics();
            })
        }
    }
    
    
    const toggleSingleDeactivation = (id) => { 
        setDeactivateEmployeeId(id);
        setDeactivateEmployeeOpen(true);
    }


    const deactivateSingleEmployee = (reason) => {
        dispatch(employeesAction.deactivateEmployee(deactivateEmployeeId, reason)).then(() => {
            setDeactivateEmployeeId("");
            getEmployees();
            getEmployeesMetrics();
        })
    }
    

    /* const archiveEmployee = async (id) => {
        const result = await DialogBox({
			title: "Delete Employee 😰",
			content: "Are you sure you want to delete this employee? Details of this employee will be erased if you choose to continue.",
			buttonYes: "Delete Employee",
			buttonYesClass: "btn-ep-red",
			buttonNo: "No, thanks",
		});
		if (result) {
            dispatch(employeesAction.archiveEmployee(id)).then(() => {
                getEmployees();
                getEmployeesMetrics();
            })
        }
    } */

    const processBulkActionOptions = () => {
        let bulkActions = {
            activate: false,
            deactivate: false,
            delete: true,
        };
        selections?.filter((selection) => {
            const employee = JSON.parse(selection);
            if (employee.disabled){
                bulkActions = {...bulkActions, activate: true};
            }
            if (!employee.disabled){
                bulkActions = {...bulkActions, deactivate: true};
            }
            return null;
        });
        setShowBulkActions(bulkActions);
    }


    const bulkActivateEmployees = async () => {
        const result = await DialogBox({
			title: "Activate Employees",
			content: "Are you sure you want to activate the selected employees? The employees will have access to Earnipay",
			buttonYes: "Activate",
			buttonNo: "Cancel",
		});
		if (result) {
            const employeeIds = selections.map((selection) => JSON.parse(selection)?._id);
            const params = {employeeIds}
            dispatch(employeesAction.bulkActivateEmployees(params));
        }
    }


    const bulkDeactivateEmployees = async () => {
        const result = await DialogBox({
			title: "Deactivate Employees",
			content: "Are you sure you want to deactivate the selected employees? Employees will no longer have access to Earnipay",
			buttonYes: "Deactivate",
            buttonYesClass: "text-white btn-red",
			buttonNo: "No, thanks",
		});
		if (result) {
            const employeeIds = selections.map((selection) => JSON.parse(selection)?._id);
            const params = {employeeIds}
            dispatch(employeesAction.bulkDeactivateEmployees(params));
        }
    }


    const bulkArchiveEmployees = async () => {
        const result = await DialogBox({
			title: "Delete Employees",
			content: "Are you sure you want to delete the selected employees? Details of these employees will be erased if you choose to continue.",
			buttonYes: "Delete Employees",
			buttonYesClass: "text-white btn-red",
			buttonNo: "No, thanks",
		});
		if (result) {
            const employeeIds = selections.map((selection) => JSON.parse(selection)?._id);
            const params = {employeeIds}
            dispatch(employeesAction.bulkArchiveEmployees(params));
        }
    }


    useEffect(() => {
        getEmployees();
        getEmployeesMetrics();
        getGroupsB2b();
        getGroups();
        dispatch(groupsAction.getAllGroups())
        // dispatch(groupsAction.getAllGroups())
        getAvailableRoles();
        logger("employer-employee-listings", userInfo);
        // eslint-disable-next-line
    }, []);


    useEffect(() => {
        processBulkActionOptions();
        // eslint-disable-next-line
    }, [selections]);


    useEffect(() => {
        if (employeeBulkActivateSuccess === true || employeeBulkDeactivateSuccess === true || employeeBulkArchiveSuccess === true){
            getEmployees();
            getEmployeesMetrics();
            clearSelections();
        }
        // eslint-disable-next-line
    }, [employeeBulkActivateSuccess, employeeBulkDeactivateSuccess, employeeBulkArchiveSuccess]);


    useEffect(() => {
        getEmployees();
        // eslint-disable-next-line
    }, [location]);

    const [uploadJobId, setUploadJobId] = useState(null);
    const [uploadDataPreview, setUploadDataPreview] = useState(null);
    const transformedRoles = employeeRoles?.employeeRoles?.map(role => ({
        display: role,
        payload: role
    }))
    
    
    
    return (
        <div>
            <DynamicHeadTag
                headerText={pageAccess === "enrolled" ? "Enrolled Employees" : "Employees"}
                headerDescription="Manage and monitor your employees' payment activity."
            />

            <EmployeeInputModal 
             setIsAddEmployeeOpen={setIsAddEmployeeOpen}
             isAddEmployeeOpen={isAddEmployeeOpen}
             getEmployees={getEmployees}
             banks={banks}
             banksLoading = {banksLoading}
            />
            
            <EmployeeViewDataModal 
                setIsViewEmployeeOpen={setIsViewEmployeeOpen}
                isViewEmployeeOpen={isViewEmployeeOpen}
                isEditEmployeeOpen={isEditEmployeeOpen}
                setIsEditEmployeeOpen={setIsEditEmployeeOpen}
                employee={employeeDetails}
                groups={groups?.data}
                banks={banks}
                banksLoading = {banksLoading}
            />
            
            <ViewGroupDataModal 
                setIsViewGroupOpen={setIsViewGroupOpen}
                isViewGroupOpen={isViewGroupOpen}
            />
            
            <EmployeeEditDetailsModal
                isOpen={isEditEmployeeOpen}
                setIsOpen={setIsEditEmployeeOpen}
                employee={employeeDetails}
                getAllGroups={getGroupsB2b}
                reloadData={getEmployees}
                banks={banks}
                banksLoading = {banksLoading}
            />
            
            <ManageEarningsModal
                isOpen={manageEarnings.isOpen}
                employee={manageEarnings.employee}
                handleToggleManageEarnings={(params) => toggleManageEarnings(params)}
                reloadData={getEmployees}
            />
            
            <EmployeeActionModal
                isOpen={isEmployeeActionOpen}
                setIsOpen={setIsEmployeeActionOpen}
                title={actionToTake === 'delete-employee' ? "Delete Employee" :"Remove This Entry"}
                question="Are you sure you want to perform this action?"
                employee={selectedEmployee}
                action={actionToTake === 'delete-employee' ? () => deleteAnEmployee(selectedEmployee) : () => {}}
            />
            
            <EditEmployeeGroupModal
                setIsEditEmployeeGroupOpen={setIsEditEmployeeGroupOpen}
                isEditEmployeeGroupOpen={isEditEmployeeGroupOpen}
            />

            <AssignToGroupModal
                assignToGroupParams={assignToGroupParams}
                reloadData={getEmployees}
                setIsAssignGroupOpen={setIsAssignGroupOpen}
                isAssignGroupOpen={isAssignGroupOpen}
                employee={employeeDetails}
            />


            <DeactivateSingleEmployeeModal
                isOpen={deactivateEmployeeOpen}
                setIsOpen={setDeactivateEmployeeOpen}
                onProceed={(reason) => deactivateSingleEmployee(reason)}
            />

            <BulkUpload
                isOpen={isOpenBulkUpload}
                setIsOpen={setIsOpenBulkUpload}
                setUploadJobId={setUploadJobId}
                setUploadDataPreview={setUploadDataPreview}
                setIsOpenBulkUploadReview={setIsOpenBulkUploadReview}
                getEmployees={getEmployees}
                banks={banks}
                banksLoading = {banksLoading}
            />
            
            <EmployeeUploadReviewCSVModal 
                pageAccess={pageAccess}
                employeesLoading={employeesLoading}
                employees={employees}
                setIsEmployeeActionOpen={setIsEmployeeActionOpen}
                isOpenBulkUploadReview={isOpenBulkUploadReview}
                setIsOpenBulkUploadReview={setIsOpenBulkUploadReview}
                jobId={uploadJobId}
                setJobId={setUploadJobId}
                uploadDataPreview={uploadDataPreview}
            />
            

            <div className="lg:flex">
                <div className="w-full lg:w-1/2">
                    <div className="page-title text-ep-deep-dark">
                        <Maybe condition={pageAccess === "all"}>
                            Employees
                        </Maybe>
                        <Maybe condition={pageAccess === "enrolled"}>
                            Enrolled Employees
                            {/* 
                            <FontAwesomeIcon data-tip data-for="info-enrolled-employees" icon="info-circle" className="ml-2 text-ep-primary" />
                            <ReactToolTip id="info-enrolled-employees" className="tooltip">
                                These are your employees that are active on Earnipay.
                            </ReactToolTip>
                             */}
                        </Maybe>
                    </div>
                </div>
            </div>


            <div className="mt-6 box">
                <div className="flex items-center justify-start w-max">
                    <h3 className="font-medium leading-7 text-lg text-ep-black pr-4">Employee List</h3>
                    <p className="font-medium label h-6 text-sm text-ep-primary-600 " style={{background: '#00535C14'}}>
                        <ContentLoading
                            loading={employeesLoading}
                            data={<>{employees?.employees?.totalDocs ?? (" " || "-")} {pluralize(employees?.employees?.totalDocs, "employee", "employees")}</>}
                        />
                    </p>
                </div>

                <Maybe condition={selections?.length === 0}>
                    <div className="flex justify-between mt-4">
                        <div className="w-full max-w-sm sm:mr-6">
                            <SearchBox placeholder="Search Employee" name="search" extraUrlParams="page=1" />
                        </div>
                        <div className="w-full flex space-x-3 justify-end">
                            <Maybe condition={pageAccess === "all"}>
                                <div>
                                    <Filter filters={[
                                        {
                                            title: "Date range",
                                            name: "period",
                                            dataType: "number-range",
                                            options: [
                                                {
                                                    payload: 1,
                                                    display: "Today",
                                                },
                                                {
                                                    payload: 7,
                                                    display: "Last 7 days",
                                                },
                                                {
                                                    payload: 30,
                                                    display: "30 days",
                                                }, 
                                                {
                                                    payload: 365,
                                                    display: "1 year",
                                                },
                                            ],
                                        },
                                        {
                                            title: "Custom date range",
                                            dataType: "date-range",
                                            options: {
                                                from: {
                                                    name: "startDate",
                                                    placeholder: "Start Date",
                                                },
                                                to: {
                                                    name: "endDate",
                                                    placeholder: "End Date",
                                                },
                                            },
                                        },
                                        {
                                            title: "Role",
                                            name: "role",
                                            dataType: "select",
                                            options: transformedRoles,
                                        },
                                        {
                                            title: "Status",
                                            name: "status",
                                            dataType: "select",
                                            options: [
                                                {
                                                    display: "All",
                                                    payload: "",
                                                },
                                                {
                                                    display: "Enrolled",
                                                    payload: "active",
                                                },
                                                {
                                                    display: "Pending",
                                                    payload: "pending",
                                                },
                                                {
                                                    display: "Deactivated",
                                                    payload: "deactivated",
                                                },
                                            ],
                                        },
                                    ]}
                                    />
                                </div>   
                            </Maybe>
   
                               {/* <Maybe condition={pageAccess === "enrolled"}> */}
                                   {/* <div>
                                       <Filter filters={[
                                           {
                                               title: "Date Added",
                                               dataType: "date-range",
                                               options: {
                                                   from: {
                                                       name: "startDate",
                                                       placeholder: "Start Date",
                                                   },
                                                   to: {
                                                       name: "endDate",
                                                       placeholder: "End Date",
                                                   },
                                               },
                                           },
                                       ]}/>
                                   </div> */}
                               {/* </Maybe> */}
   
                               <div>
                                   <DownloadAsCSV
                                       ref={downloadAsCSVRef}
                                       tooltip={`Download ${pageAccess === "enrolled" ? "enrolled " : ""}employees list`}
                                       filename={`${pageAccess === "enrolled" ? "Enrolled " : ""}Employees.csv`}
                                       columns={[
                                           { label: "Employee ID", key: "staffId" },
                                           { label: "First Name", key: "firstName" },
                                           { label: "Last Name", key: "lastName" },
                                           { label: "Email Address", key: "email" },
                                           { label: "Phone Number", key: "phoneNumber" },
                                           { label: "Net Monthly Salary", key: "netMonthlySalary" },
                                           { label: "Bank Name", key: "bankName" },
                                           { label: "Account Number", key: "bankAccountNumber" },
                                           { label: "Job Title", key: "jobTitle" },
                                           { label: "Group", key: "employeeGroup" },
                                           { label: "Date Added", key: "createdAt" },
                                           { label: "Status", key: "status" },
                                           { label: "Disabed", key: "disabled" },
                                       ]}
                                       click={() => {
                                           dispatch(employeesAction.downloadGetAllEmployees({...listParams, page: 1, limit: 10000})).then(() => {
                                               downloadAsCSVRef.current?.downloadData();
                                           });
                                       }}
                                       loading={employeesDownloadLoading}
                                       response={employeesDownload?.employees?.docs}
                                   />
                               </div>
                               <DropDown titleIcon={<ArrowDownIcon className="text-white" />} listClass="flex gap-2 item-center p-2 w-[200px] cursor-pointer hover:bg-[#00535C]" triggerClass="flex btn btn-md btn-ep-primary justify-between" title="Add Employee" dropdownArray={[
                                    {
                                        icon: <SingleUser />,
                                        title: "Add Single Employee",
                                        func: () => setIsAddEmployeeOpen((prevState) => !prevState)
                                    },
                                    {
                                        icon: <GroupUser />,
                                        title: "Add Bulk Employees",
                                        func: () => setIsOpenBulkUpload((prevState) => !prevState)
                                    }
                                    ]}/>
                            {/* <Link to="/people/employees/add" className="btn btn-md btn-ep-primary">
                                <FontAwesomeIcon icon="plus" className="w-2 h-2 mr-1 inline" />
                                New Employee
                            </Link> */}
                            {/* <button type="button" onClick={() => setIsOpenBulkUpload(true)} className="btn btn-md btn-transparent-primary">
                                Bulk Upload
                            </button> */}
                        </div>
                    </div>
                </Maybe>

                <div className={`pl-4 xl:flex flex-wrap ${selections?.length > 0 ? "justify-start" : "justify-between"} ${pageAccess === "all" ? "mt-6" : ""}`}>
                    <div className="flex-grow flex items-center">
                        {/* <div className="w-10 flex justify-center items-center">
                            <IconDotH className="h-6 svg-fill-ccc" />
                        </div> */}
                        <Maybe condition={selections?.length > 0}>
                            <div className="flex flex-wrap items-center">
                                <Maybe condition={showBulkActions?.activate === true}>
                                    <button type="button" onClick={bulkActivateEmployees} className="dropdown-item dropdown-item-icon" disabled={employeeBulkActivateLoading}>
                                        <Maybe condition={employeeBulkActivateLoading === true}>
                                            <FontAwesomeIcon icon="circle-notch" spin className="text-xl" style={{margin: "auto 0.5rem auto 0"}} />
                                        </Maybe>
                                        <Maybe condition={employeeBulkActivateLoading === false}>
                                            <IconActivate style={{height: "1.25rem", marginRight: "0.5rem"}} />
                                        </Maybe>
                                        Activate
                                    </button>
                                </Maybe>

                                <Maybe condition={showBulkActions?.deactivate === true}>
                                    <button type="button" onClick={bulkDeactivateEmployees} className="dropdown-item dropdown-item-icon" disabled={employeeBulkDeactivateLoading}>
                                        <Maybe condition={employeeBulkDeactivateLoading === true}>
                                            <FontAwesomeIcon icon="circle-notch" spin className="text-xl" style={{margin: "auto 0.5rem auto 0"}} />
                                        </Maybe>
                                        <Maybe condition={employeeBulkDeactivateLoading === false}>
                                            <IconDeactivate style={{height: "1.25rem", marginRight: "0.5rem"}} />
                                        </Maybe>
                                        Deactivate
                                    </button>
                                </Maybe>
                                
                                <Maybe condition={showBulkActions?.delete === true}>
                                    <button type="button" onClick={bulkArchiveEmployees} className="dropdown-item dropdown-item-icon text-red-500" disabled={employeeBulkArchiveLoading}>
                                        <Maybe condition={employeeBulkArchiveLoading === true}>
                                            <FontAwesomeIcon icon="circle-notch" spin className="text-xl" style={{margin: "auto 0.5rem auto 0"}} />
                                        </Maybe>
                                        <Maybe condition={employeeBulkArchiveLoading === false}>
                                            <IconTrash style={{height: "1.25rem", marginRight: "0.5rem"}} />
                                        </Maybe>
                                        Delete
                                    </button>
                                </Maybe>

                                <div className="mx-2 sm:mx-6">
                                    <div className="w-0.5 h-4 bg-gray-200"></div>
                                </div>

                                <div className="flex space-x-4">
                                    <div className="text-[#6C757D]">
                                        {selections?.length} selected
                                    </div>
                                    <button type="button" onClick={clearSelections}>
                                        <IconsTimes className="svg-fill-red" />
                                    </button>
                                </div>
                            </div>
                        </Maybe>
                        
                    </div>
                </div>


                <div>
                    <ActiveFilter filters={{"Status": "status", "Start Date": "startDate", "End Date": "endDate"}} />
                </div>
                
                
                <div className="mt-6">
                    <div ref={printComponentRef}>

                        <div className="mb-4 text-xl hidden print:block">
                            <Maybe condition={pageAccess === "all"}>
                                Employees
                            </Maybe>
                            <Maybe condition={pageAccess === "enrolled"}>
                                Enrolled Employees
                            </Maybe>
                        </div>
                        
                        <Table>
                            <Table.Head>
                                <th>
                                    <div className="flex">
                                        <input type="checkbox" className="form-checkbox w-5 h-5 multi-select-header" onChange={toggleMultiSelectHeader} />
                                    </div>
                                </th>
                                <th>First Name</th>
                                <th>Last Name</th>
                                <th>Email Address</th>
                                <th>Phone Number</th>
                                {/* <th>Date Added</th> */}
                                <th>Role</th>
                                <Maybe condition={pageAccess === "all"}>
                                    <th>Status</th>
                                </Maybe>
                                <Maybe condition={pageAccess === "enrolled"}>
                                    <th>Earnings</th>
                                </Maybe>
                                <th></th>
                            </Table.Head>
                            <Table.Body>

                                <TableContent
                                    loading={employeesLoading}
                                    loadingText={`Loading ${pageAccess === "enrolled" ? "enrolled " : ""}employees`}
                                    data={employees?.employees}
                                    colspan={8}
                                />

                                {employeesLoading === false && employees?.employees?.docs?.map((employee) =>
                                    <tr key={employee._id}>
                                        <td>
                                            <input
                                                type="checkbox"
                                                className="form-checkbox w-5 h-5 multi-select"
                                                onChange={getMultiSelectBody}
                                                checked={selections?.filter((selection) => JSON.parse(selection)._id === employee._id).length === 1}
                                                value={JSON.stringify(employee)}
                                            />
                                        </td>
                                        <td>
                                            <div className="flex space-x-1">
                                                <div className="capitalize">
                                                    {employee.firstName}
                                                </div>
                                                <Maybe condition={employee.stopEarning === true || employee.stopEarningFrom !== null}>
                                                    <div>
                                                        <FontAwesomeIcon data-tip data-for={"info-stop-earnings-" + employee._id} icon="info-circle" className="text-red-500 text-lg" />
                                                        <ReactToolTip id={"info-stop-earnings-" + employee._id} className="tooltip">
                                                            <Maybe condition={employee.stopEarning === true}>
                                                                <div className="label label-red">
                                                                    Earnings OFF
                                                                </div>
                                                            </Maybe>
                                                            <Maybe condition={employee.stopEarning === false && employee.stopEarningFrom !== null}>
                                                                <div className="label label-red">
                                                                    Earnings OFF (scheduled)
                                                                </div>
                                                            </Maybe>
                                                            <div className="mt-2 text-white text-center">
                                                                <Maybe condition={employee.stopEarningFrom !== null}>
                                                                    {DateFormat(employee.stopEarningFrom)} -&nbsp;
                                                                    {(employee.stopEarningTo !== null) ? DateFormat(employee.stopEarningTo) : "infinity" }
                                                                </Maybe>
                                                            </div>
                                                        </ReactToolTip>
                                                    </div>
                                                </Maybe>
                                            </div>
                                        </td>
                                        <td className="capitalize">
                                            {employee?.lastName}
                                        </td>
                                        <td>
                                            {employee.email}
                                        </td>
                                        <td>
                                            {employee.phoneNumber}
                                        </td>
                                        {/* <td>
                                            {DateFormat(employee.createdAt)}
                                        </td> */}
                                        <td className="capitalize">
                                            {employee.jobTitle}
                                        </td>
                                        <td>
                                            <Maybe condition={pageAccess === "all"}>
                                                <Maybe condition={employee.disabled === true}>
                                                    <div className={"label " + renderStatusColor("disabled")}>
                                                        Deactivated
                                                    </div>
                                                </Maybe>
                                                <Maybe condition={employee.disabled === false}>
                                                    <div className={"label capitalize " + renderStatusColor(employee.disabled === false ? "active" : "deactivated")}>
                                                        {employee.disabled === false ? "active" : "deactivated"}
                                                    </div>
                                                </Maybe>
                                            </Maybe>
                                            
                                            <Maybe condition={pageAccess === "enrolled"}>
                                                <Maybe condition={employee.stopEarning === false}>
                                                    <div className="label label-green">
                                                        On
                                                    </div>
                                                </Maybe>
                                                <Maybe condition={employee.stopEarning === true}>
                                                    <div className="label label-red">
                                                        Off
                                                    </div>
                                                </Maybe>
                                            </Maybe>
                                        </td>
                                        <td>
                                    <DropdownNew flipSwitch={true}>
                                                <></>
                                                <div>
                                                    <div onClick={
                                                        () => {
                                                            setIsViewEmployeeOpen((prevData) => !prevData);
                                                            setEmployeeDetails(employee)
                                                        }
                                                    } className="dropdown-item">View Details</div>
                                                    <div onClick={() => {
                                                        setEmployeeDetails(employee);
                                                        setIsEditEmployeeOpen((prevData) => !prevData);
                                                        }} className="dropdown-item">Edit Details</div>
                                                    <div 
                                                        onClick={
                                                            () => {
                                                                setEmployeeDetails(employee);
                                                                setIsAssignGroupOpen((prevState) => !prevState);
                                                            }
                                                        } 
                                                        className="dropdown-item"
                                                    >
                                                        Assign to Group
                                                    </div>
                                                    <div 
                                                        onClick={() => {
                                                            if (employee.disabled) {
                                                                activateEmployee(employee._id);
                                                            } else {
                                                                toggleSingleDeactivation(employee._id);
                                                            }
                                                        }} 
                                                        className="dropdown-item"
                                                    >
                                                        {employee.disabled ? "Reactivate Employee" : "Deactivate Employee"}
                                                    </div>
                                                    <div onClick={
                                                        () => {
                                                            setIsEmployeeActionOpen((prevState) => !prevState);
                                                            setActionToTake('delete-employee')
                                                            setSelectedEmployee(employee);
                                                        }
                                                    } className="dropdown-item text-red-500">Delete Employee</div>
                                                </div>
                                    </DropdownNew>
                                        </td>
                                    </tr>
                                )}

                            </Table.Body>
                        </Table>

                        <Maybe condition={employeesLoading === false && employees?.employees?.docs?.length > 0}>
                            <div className="mt-6">
                                <Pagination data={employees?.employees} />
                            </div>
                        </Maybe>

                    </div>
                </div>
            </div>

        </div>
    )
}




// const AssignToGroupModal = (props) => {
//     const {assignToGroupParams} = props;
//     const dispatch = useDispatch();
//     const { getAllGroupsLoading, allGroups: groups, assignEmployeeToGroupLoading, assignEmployeeToGroupSuccess } = useSelector((s) => s.entities.groups);
    
//     const [params, setParams] = useState(assignToGroupParams);
    
    
//     const selectGroup = (groupId) => {
//         setParams({
//             ...params,
//             params: {
//                 ...params.params,
//                 policyId: groupId
//             }
//         })
//     }


//     const submitForm = (e) => {
//         e.preventDefault();
//         const errors = validate(params.params);
//         if (errors){
//             for (var x in errors) {
//                 toast.error(errors[x]);
//             };
//             return;
//         }
//         else{
//             const payload = {
//                 policyId: params.params.policyId,
//                 employeeIds: params.params.employeeId,
//             }
//             dispatch(groupsAction.assignEmployeeToGroup(payload));
//         }
//     }


//     useEffect(() => {
//         setParams(assignToGroupParams);
//     }, [assignToGroupParams])


//     useEffect(() => {
//         if (assignEmployeeToGroupSuccess === true){
//             setParams({...params, isOpen: false});
//             props.reloadData();
//         }
//         // eslint-disable-next-line
//     }, [assignEmployeeToGroupSuccess])
    

//     return (
//         <FormDrawer display="center" size="sm" isOpen={true} setIsOpen={() => setParams({...params, isOpen: false})}>
//             <form onSubmit={submitForm} className="p-8">
//                 <div className="font-bold text-[#0D0C2B] text-lg sm:text-xl">
//                     Assign to group
//                 </div>

//                 <PageContent
//                     loading={getAllGroupsLoading}
//                     data={groups}
//                     loadingText="Loading groups..."
//                     emptyText="No group yet"
//                     errorText="Unable to load groups"
//                 />

//                 <Maybe condition={getAllGroupsLoading === false && groups?.policies && groups?.policies?.length > 0}>
//                     <div className="mt-8">
//                         <Input type="text" label="Full name" value={params.employee} disabled={true} />

//                         <SelectInput label="Select from group" value={params.params.policyId} onChange={(e) => selectGroup(e.target.value)}>
//                             <option value="">Select Group</option>
//                             <option value="general-group">General Group</option>
//                             {groups?.policies?.map(group => (
//                                 <option key={group._id} value={group._id}>{group.name}</option>
//                             ))}
//                         </SelectInput>

//                         <div className="-mt-3">
//                             <Link to="/groups/create" target="_blank" className="flex space-x-2 items-center justify-start text-ep-primary hover:underline">
//                                 <FontAwesomeIcon icon="plus" className="w-2 h-2 mr-1 inline" />
//                                 Create new group
//                             </Link>
//                         </div>

//                         <div className="mt-8 flex space-x-3 justify-start">
//                             <ButtonLoader type="submit" loading={assignEmployeeToGroupLoading} className="btn btn-md btn-ep-primary">
//                                 Assign to Group
//                             </ButtonLoader>
//                             <button type="button" onClick={() => setParams({...params, isOpen: false})} className="btn btn-md btn-transparent-primary">
//                                 Cancel
//                             </button>
//                         </div>
//                     </div>
//                 </Maybe>
//             </form>
//         </FormDrawer>
//     )
// }




const DeactivateSingleEmployeeModal = (props) => {
    const {isOpen, setIsOpen, onProceed} = props;
    const [form, setForm] = useState({
        defaultReason: "",
        otherReason: "",
    });

    const reasons = ["Resignation", "Termination", "End of Contract", "Others"];

    const onSubmit = (e) => { 
        e.preventDefault();
        if(!form.defaultReason) {
            toast.error("Please select a reason for deactivation");
        } 
        else if(form.defaultReason === "Others" && !form.otherReason) {
            toast.error("Please specify a reason in the text field");
        }
        else {
            const payload = {
                reason: form.defaultReason === "Others" ? `Others - ${form.otherReason}` : form.defaultReason
            }
            setIsOpen(!isOpen);
            onProceed(payload);
            e.target.reset();
        }
    }

    const updateDefaultReason = (e) => {
        setForm({
            ...form,
            defaultReason: e.target.value,
            otherReason: "",
        })
    }

    return (
        <FormDrawer display="center" size="sm" isOpen={isOpen} setIsOpen={setIsOpen}>
            <div className="p-8">
                <div className="font-dm-sans font-bold text-[#0D0C2B] text-lg sm:text-xl">
                    Deactivate Employee 😯
                </div>
                <div className="mt-6 font-dm-sans text-[#343A40]">
                    Are you sure you want to deactivate this employee? Employee will no longer have access to Earnipay
                </div>

                <div>
                    <form onSubmit={onSubmit}>
                        <div className="mt-8 mb-6">
                            <SelectInput 
                                required 
                                label="Reason for Deactivation" 
                                value={form.defaultReason} 
                                onChange={updateDefaultReason}>
                                <option value="">Select reason</option>
                                {reasons.map((reason) => (
                                    <option key={reason} value={reason}>{reason}</option>
                                ))}
                            </SelectInput>

                            <Maybe condition={form.defaultReason === "Others"}>
                                <Input
                                    required
                                    type="text" 
                                    label="Specify Reason" 
                                    value={form.otherReason || ""}
                                    onChange={(e) => setForm({...form, otherReason: e.target.value})}
                                />
                            </Maybe>
                        </div>
                        <div className="mt-8 flex space-x-4 justify-start">
                            <button type="submit" className="btn btn-ep-red" autoFocus={true}>
                                Deactivate
                            </button>
                            <button type="button" className="btn btn-transparent-primary" onClick={() => setIsOpen(!isOpen)}>
                                No, thanks
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </FormDrawer>
    )
}



export default List;
